import { Component, OnInit, Input } from '@angular/core';

import { Vendor } from '../../../models/vendor';

import { AddressService } from '../../../services/contacts/address.service';
import { AlertService } from '../../../services/common/alert.service';
import { VendorService } from '../../../services/accounting/vendor.service';

@Component({
  selector: 'app-vendor-form',
  templateUrl: './vendor-form.component.html',
  styleUrls: ['./vendor-form.component.css'],
})
export class VendorFormComponent implements OnInit {
  @Input() vendor: Vendor = new Vendor();

  addresses: Array<any> = [];

  formOptions: any = {
    chart_of_accounts: [],
  };

  contact_name: string;

  formSubmitted: boolean = false;
  formSubmitting: boolean = false;

  constructor(private addressService: AddressService, private alertService: AlertService, private vendorService: VendorService) {
    this.vendorService.getFormOptions().then((response_json) => {
      this.formOptions = response_json;
      this.formOptions.chart_of_accounts = [{}].concat(this.formOptions.chart_of_accounts);
    });
  }

  // Component lifecycle methods
  ngOnInit() {
    if (this.vendor.id) {
      this.contact_name = this.vendor.contact_name;
      this.loadAddresses();
    }
  }

  // Component methods
  loadAddresses() {
    if (this.vendor.contact_id)
      this.addressService
        .getAddresses({
          get_simple_addresses: true,
          contact_id: this.vendor.contact_id,
        })
        .then((response_json) => (this.addresses = [{}].concat(response_json)));
  }

  onContactSelect(event: any) {
    this.vendor.contact_id = Number(event.id);
    this.contact_name = event.label;
    this.loadAddresses();
  }

  submitForm() {
    let scope: VendorFormComponent = this;
    this.formSubmitted = true;
    if (this.validVendor()) {
      this.formSubmitting = true;
      this.alertService.alert_status_info_overlay('Saving Vendor <i class="fas fa-spinner fa-pulse fa-fw"></i>');
      this.vendorService
        .saveVendor({ vendor: this.vendor })
        .then((response_json) => {
          this.alertService.alert_status_clear_overlay();
          this.alertService.alert_status_success('Vendor saved');
          window.history.back();
        })
        .catch((error: any) => {
          console.log(error);
          scope.formSubmitting = false;
          scope.alertService.alert_status_clear_overlay();
          scope.alertService.alert_status_danger('Error saving vendor');
        });
    }
  }

  validVendor(): boolean {
    if (!this.vendor.contact_id || !this.vendor.address_id || !this.vendor.chart_of_account_id) return false;
    else return true;
  }
}
